import { cn } from '../lib/cn';

type Size = 'sm' | 'md' | 'lg';

const SIZE: Record<Size, string> = {
  sm: 'h-8 w-8 text-ops-caption',
  md: 'h-10 w-10 text-ops-label',
  lg: 'h-12 w-12 text-ops-body',
};

function initials(name: string): string {
  return name
    .trim()
    .split(/\s+/)
    .slice(0, 2)
    .map((w) => w[0]?.toUpperCase() ?? '')
    .join('');
}

// Детерминированный оттенок из имени — стабильная неядовитая палитра.
const PALETTE = ['#683DFF', '#2D7FF9', '#15A05A', '#E08A0C', '#E5484D', '#8A5CF6'];
function hueFor(name: string): string {
  let h = 0;
  for (let i = 0; i < name.length; i++) h = (h * 31 + name.charCodeAt(i)) >>> 0;
  return PALETTE[h % PALETTE.length];
}

export function Avatar({
  name,
  src,
  size = 'md',
  className,
}: {
  name: string;
  src?: string;
  size?: Size;
  className?: string;
}) {
  if (src) {
    return <img src={src} alt={name} className={cn('rounded-full object-cover', SIZE[size], className)} />;
  }
  return (
    <span
      className={cn('inline-flex select-none items-center justify-center rounded-full font-semibold text-white', SIZE[size], className)}
      style={{ backgroundColor: hueFor(name) }}
      aria-label={name}
    >
      {initials(name)}
    </span>
  );
}
